import { GridReducer } from '../common/grid/grid.reducer';
import merge from 'lodash/merge';
import set from 'lodash/set';

/** @namespace Reducers.SafetyPlan */

export function safetyPlanReducer(state, action) {

    if (typeof state === 'undefined') {
        return {
            safetyPlanDocumentLocationsGrid: merge(
                set(GridReducer(), 'itemsCount', undefined),
                {
                    filter: {
                        limit: 100
                    }
                }
            )
        };
    }

    switch (action.type) {

        case 'GRID_OVERRIDE':
        case 'SHOW_LOADING':
        case 'PAGINATE':
        case 'GRID_RELOAD':
        case 'GRID_FETCH':
        case 'GRID_RESET':
        case 'GRID_INIT':
            if (action.id === 'safetyPlanDocumentLocationsGrid') {
                return Object.assign({}, state, {
                    safetyPlanDocumentLocationsGrid: GridReducer(
                        state.safetyPlanDocumentLocationsGrid,
                        action
                    )
                });
            }
            break;

        case 'GRID_SELECT_ALL':
        case 'GRID_DESELECT_ALL':
            if (action.id === 'safetyPlanDocumentLocationsGrid') {
                return Object.assign({}, state, {
                    safetyPlanDocumentLocationsGrid: GridReducer(
                        state.safetyPlanDocumentLocationsGrid,
                        action
                    )
                });
            }
            break;

        case 'GRID_SELECT':
            if (action.id === 'safetyPlanDocumentLocationsGrid') {
                return Object.assign({}, state, {
                    safetyPlanDocumentLocationsGrid: set(
                        GridReducer(
                            state.safetyPlanDocumentLocationsGrid,
                            action
                        ),
                        'changedItem',
                        {
                            id: action.data,
                            checked: 1
                        }
                    )
                });
            }
            break;

        case 'GRID_DESELECT':
            if (action.id === 'safetyPlanDocumentLocationsGrid') {
                return Object.assign({}, state, {
                    safetyPlanDocumentLocationsGrid: set(
                        GridReducer(
                            state.safetyPlanDocumentLocationsGrid,
                            action
                        ),
                        'changedItem',
                        {
                            id: action.data,
                            checked: 0
                        }
                    )
                });
            }
            break;

        default:
            return state;
    }

    return state;
}